document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".login-store-locator");
  if (!sections.length) return;

  function escapeHTML(value) {
    const div = document.createElement("div");
    div.textContent = value || "";
    return div.innerHTML;
  }

  sections.forEach(function (section) {
    const sectionId = section.id.replace("login-store-locator-", "");
    const mapElement = document.getElementById("store-map-" + sectionId);

    if (!mapElement || typeof L === "undefined") return;

    const stores = window.loginStoreData?.[sectionId] || [];
    const defaultLat = parseFloat(mapElement.dataset.defaultLat) || 30.3753;
    const defaultLng = parseFloat(mapElement.dataset.defaultLng) || 69.3451;
    const defaultZoom = parseInt(mapElement.dataset.defaultZoom) || 6;

    /* Initialize Leaflet Map Instance */
    const map = L.map(mapElement, { scrollWheelZoom: false }).setView([defaultLat, defaultLng], defaultZoom);

    /* Google Maps Standard Tile Layer (No Watermark) */
    L.tileLayer("https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}", {
      maxZoom: 20,
      attribution: '© Google Maps'
    }).addTo(map);

    /* SVG Pin Marker Setup (Google Pin Style) */
    const pinIcon = L.divIcon({
      className: "login-custom-pin-wrap",
      html: `
        <svg width="32" height="42" viewBox="0 0 384 512" fill="none" style="display:block; filter: drop-shadow(0px 2px 4px rgba(0,0,0,0.3));">
          <path fill="#EA4335" d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"/>
          <circle cx="192" cy="192" r="75" fill="#FFFFFF"/>
        </svg>
      `,
      iconSize: [32, 42],
      iconAnchor: [16, 42],
      popupAnchor: [0, -38]
    });

    const markers = {};

    /* Create Map Markers & Popups */
    stores.forEach(function (store) {
      const lat = parseFloat(store.latitude);
      const lng = parseFloat(store.longitude);

      if (Number.isNaN(lat) || Number.isNaN(lng)) return;

      const storeName = store.name || '';
      const storeAddr = store.address || '';

      /* Standard Exact Google Maps Place / Directions Link */
      const directionsUrl = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}&query_place_id=ChIJ32N3HnQ-sz4RrEK8qxV4IPY`;

      const marker = L.marker([lat, lng], { icon: pinIcon }).addTo(map);

      marker.bindPopup(`
        <div style="padding:6px; font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif; min-width:170px;">
          <strong style="font-size:13px; color:#202124; display:block; margin-bottom:4px; font-weight:600;">${escapeHTML(storeName)}</strong>
          <span style="font-size:11px; color:#5f6368; display:block; margin-bottom:10px; line-height:1.4;">${escapeHTML(storeAddr)}</span>
          <a href="${directionsUrl}" target="_blank" rel="noopener noreferrer" style="display:inline-block; font-size:12px; color:#1a73e8; font-weight:500; text-decoration:none;">↗ Get Directions</a>
        </div>
      `);

      marker.on("click", function () {
        highlightAndScrollCard(store.id);
        map.flyTo([lat, lng], 18, { animate: true, duration: 1.2 });
      });

      markers[store.id] = marker;
    });

    /* Highlight Corresponding Card in Grid */
    function highlightAndScrollCard(storeId) {
      const cards = section.querySelectorAll("[data-store-card]");
      cards.forEach(card => card.classList.remove("is-active"));

      const targetCard = section.querySelector(`[data-store-id="${storeId}"]`);
      if (targetCard) {
        targetCard.classList.add("is-active");
        targetCard.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }

    /* Map Navigation & Auto-Scroll Handler */
    function focusMapOnStore(lat, lng, storeId, cardEl, shouldScrollMap = false) {
      if (Number.isNaN(lat) || Number.isNaN(lng)) return;

      if (shouldScrollMap && mapElement) {
        mapElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }

      map.invalidateSize();
      map.flyTo([lat, lng], 18, { animate: true, duration: 1.2 });

      const cards = section.querySelectorAll("[data-store-card]");
      cards.forEach(c => c.classList.remove("is-active"));
      if (cardEl) cardEl.classList.add("is-active");

      if (storeId && markers[storeId]) {
        markers[storeId].openPopup();
      }
    }

    /* Event Listeners: Store Cards Click */
    const cards = section.querySelectorAll("[data-store-card]");
    cards.forEach(function (card) {
      card.addEventListener("click", function (e) {
        if (e.target.closest("a") || e.target.closest("button")) return;
        const lat = parseFloat(card.dataset.lat);
        const lng = parseFloat(card.dataset.lng);
        focusMapOnStore(lat, lng, card.dataset.storeId, card, false);
      });
    });

    /* Event Listeners: View on Map Button Click */
    const mapButtons = section.querySelectorAll("[data-view-map]");
    mapButtons.forEach(function (button) {
      button.addEventListener("click", function (e) {
        e.stopPropagation();
        const currentCard = button.closest("[data-store-card]");
        const storeId = button.dataset.storeId || currentCard?.dataset.storeId;
        const lat = parseFloat(button.dataset.lat || currentCard?.dataset.lat);
        const lng = parseFloat(button.dataset.lng || currentCard?.dataset.lng);

        focusMapOnStore(lat, lng, storeId, currentCard, true);
      });
    });

    /* Responsiveness Handling */
    window.addEventListener("resize", () => {
      setTimeout(() => map.invalidateSize(), 200);
    });
  });
});